var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMtsPayLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 32 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "#e30600",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.17 13.47c0 2.76 1.5 5.53 4.83 5.53 3.32 0 4.83-2.77 4.83-5.53a12 12 0 0 0-1.64-5.78C18.2 6.02 17 5 16 5c-1.02 0-2.2 1.01-3.19 2.7a12.14 12.14 0 0 0-1.64 5.77"
})));
export default SvgMtsPayLight;